const baseStrings = {
  APP: {
    locale: 'en-US',
    lang: 'English',
    confirmed: 'Confirmed',
    forest: 'Forest',
    colon: ': ',
    introTitle: [
      'Whether you are at ease or worried,',
      'it is best to be able to grasp the situation around you.',
    ].join('\n'),
    introBody: [
      'Use ConfirmedForest™ to record your contacts.',
      'You could see the distance (how many layers) and auto-calculated statistics between any possible disease with you.',
      'Thus, you could do the corresponding epidemic prevention measures.',
    ].join('\n'),
    hint: [
      'The goal of ConfirmedForest™ is to help the government and the public to track the source of the outbreak more quickly. By logging to our system with your phone number, and adding the identity that has been in close contact with yourself (without maintaining social distance), we could help you count the possible symptoms of contacts within three degrees.',
      'If everyone records their contacts, you could see the distance (how many layers) and auto-calculated statistics between any possible disease with you, and do the corresponding anti-epidemic measures. Whether you are at ease or worried, it is best to be able to grasp the situation around you.',
      'Reduce going out, avoid gathering, wear masks, wash your hands frequently, and wish everyone good health.',
      '* Note: all personal resources are for individual statistics, tracking, and reminding of your health management.',
    ].join('\n'),
    contactUs: 'Contact Us',
  },
  LOGIN_SECTION: {
    hint: [
      'This phone number is only used to add contacts and set your symptoms.',
      "* Note: please don't use others' cell phone numbers without permission to avoid suspected rumors.",
    ].join('\n'),
    title: 'Please enter your phone number',
    label: 'Phone number',
    placeholder: 'Please enter your phone number',
    emptyWarning: 'You must provide your unique phone number',
    invalidWarning: 'You must provide a valid phone number',
    dialogAlertTitle: "We're retrieving your information...",
    dialogAlertDescription: 'Please wait a second. Thank you for your patience.',
  },
  SYMPTOM_SECTION: {
    hint: [
      'Enter your current symptoms.',
      "Don't worry, others can't see your symptoms.",
      'They will only appear in the summary statistics to help everyone understand the risk of exposure history to help others and yourself.',
    ].join('\n'),
    title: 'Select your symptoms',
    warning: 'You must select a symptom',
  },
  SYMPTOM: {
    confirmed: 'Confirmed COVID-19',
    cough: 'Cough',
    difficultyBreathing: 'Difficulty breathing',
    fever: 'Fever',
    musclePain: 'Muscle pain',
    newLossOfTasteOrSmell: 'New loss of taste or smell',
    quarantine: 'Quarantine',
    soreThroat: 'Sore throat',
  },
  CONTACT_SECTION: {
    hint: 'Could enter family and friends, or anyone who feels at risk of infectious diseases.',
    title: 'Add new contacts',
    label: "Your contact's phone number",
    today: 'Today',
    contactOfNDaysBefore: (n: number) => `Contacts of ${n} day${n > 1 ? 's' : ''} before`,
    placeholder: "Please enter your contact's phone number",
    emptyWarning: "You must provide your contact's phone number",
    invalidWarning: 'You must provide a valid phone number',
  },
  STATISTIC_SECTION: {
    title: 'Stats today',
    nLevelContacts: [
      'Contacts within the first degree',
      'Contacts within the second degree',
      'Contacts within the third degree',
    ],
    peopleUnit: 'people',
  },
  BUTTON: {
    submit: 'Submit',
    login: 'Login to see the report',
    loading: 'Loading...',
    saving: 'Saving...',
    edit: 'Edit',
    cancel: 'Cancel',
    delete: 'Delete',
    refreshContact: 'Refresh contact',
  },
  ALERT: {
    loginFail: 'Login failed: please check the network connection or try again later',
    undefinedPhoneNumber: 'Undefined phone number',
  },
  DIALOG: {
    contact: 'Contact',
    lastContactDate: 'Last contact date',
    contactRefresh: 'If you have contacted this contact today, you could refresh the date.',
    contactDelete: 'You could delete the person you wrongly added.',
  },
};

export type AppStrings = typeof baseStrings;
export const en = baseStrings;
